/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Modal, Form } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import FileSaver from 'file-saver';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import {
  SPDX_EXTENSION_JSON,
  SPDX_EXTENSION_XML,
  SPDX_EXTENSION_RDF,
  SPDX_EXTENSION_YAML,
  SPDX_EXTENSION_TAG,
} from '../../constants/reports';
import './SPDXDocumentGenerator.css';

class SPDXDocumentGenerator extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      isOpenMCX: props.isOpenMCX,
      isDownloadLoading: false,
      isLoading: false,
      isOpenWarnModal: false,
      creatorName: '',
      creatorEmail: '',
      orgName: '',
      orgEmail: '',
      creatorComment: '',
      documentComment: '',
      modalValue: '',
      exportFormat: SPDX_EXTENSION_JSON,
      creatorNameError: false,
      orgNameError: false,
      spdxType: '2.0'
    };
    this.handleCreatorNameChange = this.handleCreatorNameChange.bind(this);
    this.handleCreatorEmailChange = this.handleCreatorEmailChange.bind(this);
    this.handleOrgNameChange = this.handleOrgNameChange.bind(this);
    this.handleOrgEmailChange = this.handleOrgEmailChange.bind(this);
    this.handleCreatorCommentChange = this.handleCreatorCommentChange.bind(this);
    this.handleDocumentCommentChange = this.handleDocumentCommentChange.bind(this);
    this.handleExportFormat = this.handleExportFormat.bind(this);
    this.handleSPDXType = this.handleSPDXType.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.runWithModalValue = this.runWithModalValue.bind(this);
    this.createSPDXFileDownload = this.createSPDXFileDownload.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCX } = this.props;
    if (prevProps.isOpenMCX !== isOpenMCX) {
      this.setState({
        isOpenMCX,
        modalValue: '',
        isOpenWarnModal: false,
        creatorName: '',
        creatorEmail: '',
        orgName: '',
        orgEmail: '',
        creatorComment: '',
        documentComment: '',
        exportFormat: SPDX_EXTENSION_JSON,
        creatorNameError: false,
        orgNameError: false,
        spdxType: '2.0'
      }, () => {
        if (isOpenMCX) {
          this.getPacakageInfoWithSpdx();
        }
      });
    }
  }

  handleCreatorNameChange(e) {
    this.setState({
      creatorName: e.target.value,
    });
  }

  handleCreatorEmailChange(e) {
    this.setState({
      creatorEmail: e.target.value,
    });
  }

  handleOrgNameChange(e) {
    this.setState({
      orgName: e.target.value,
    });
  }

  handleOrgEmailChange(e) {
    this.setState({
      orgEmail: e.target.value,
    });
  }

  handleCreatorCommentChange(e) {
    this.setState({
      creatorComment: e.target.value,
    });
  }

  handleDocumentCommentChange(e) {
    this.setState({
      documentComment: e.target.value,
    });
  }

  handleExportFormat(e) {
    const { spdxType } = this.state;
    if (spdxType !== '3.0') {
      this.setState({
        exportFormat: e.target.value,
      });
    }
  }

  handleSPDXType(e) {
    const { exportFormat } = this.state;
    const newSpdxType = e.target.value;
    this.setState({
      spdxType: e.target.value,
      exportFormat: newSpdxType === '3.0' ? SPDX_EXTENSION_JSON : exportFormat,
    });
  }

  onSubmit() {
    const { translate } = this.props;
    if (!this.validateForm()) {
      return;
    }

    this.modalHeader = translate('modal.title.notice');
    this.modalBody = translate('modal.message.create_document');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'create',
    });
  }

  validateForm = () => {
    const {
      creatorName, orgName,
    } = this.state;

    const validation = {
      creatorName: true,
      orgName: true,
    };

    if (creatorName.trim().length === 0) {
      this.setState({
        creatorNameError: true,
      });
      validation.creatorName = false;
      this.creatorName.focus();
      this.creatorName.scrollIntoView();
      return false;
    }

    if (orgName.trim().length === 0) {
      this.setState({
        orgNameError: true,
      });
      validation.orgName = false;
      this.orgName.focus();
      this.orgName.scrollIntoView();
      return false;
    }

    return validation.creatorName && validation.orgName;
  };

  getPacakageInfoWithSpdx = () => {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getPacakageInfoWithSpdx(reportId)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            creatorName: data.creatorName,
            creatorEmail: data.creatorEmail,
            orgName: data.organizationName,
          });

        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  createSPDXFileDownload = () => {
    const {
      reportId, closeModal, state, uploadedFileName
    } = this.props;
    const {
      isDownloadLoading,
      exportFormat,
      creatorName,
      creatorEmail,
      creatorComment,
      orgName,
      orgEmail,
      documentComment,
      //copyrightText,
      spdxType,
    } = this.state;

    const obj = {
      export_format: exportFormat,
      creator_name: creatorName, //required
      creator_email: creatorEmail,
      creator_comment: creatorComment,
      organization_name: orgName, //required
      organization_email: orgEmail,
      document_comment: documentComment,
      document_namespace: `https://spdx.org/spdxdocs/Insignary-Clarity-${uuidv4()}`, //required
    };

    if (spdxType === '3.0') {
      obj.profile = 'all';
    }

    if (state.user.currentPrecisionLevel) {
      obj.precision_level = state.user.currentPrecisionLevel;
    }

    const fileName = `sbom.spdx.clarity-${uploadedFileName}.${exportFormat}`;

    if (isDownloadLoading) {
      api
        .createSPDXFileDownload(reportId, obj)
        .then((res) => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, fileName);

          this.setState({
            isDownloadLoading: false,
          });
          closeModal();
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDownloadLoading: false,
          });
          closeModal();
        });
    }
  };

  runWithModalValue() {
    const { closeModal } = this.props;
    const { modalValue } = this.state;

    if (modalValue.indexOf('create') > -1) {
      this.setState({
        isOpenWarnModal: false,
        isDownloadLoading: true,
      }, () => {
        this.createSPDXFileDownload();
      });
    } else {
      closeModal();
    }
  }

  closeModal(e) {
    const { translate } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }

    this.modalHeader = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document_cancel');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'MCX',
    });
  }

  closeWarnModal() {
    this.setState({
      isOpenWarnModal: false,
    });
  }

  render() {
    const { translate } = this.props;
    const {
      //rowData,
      isOpenWarnModal,
      //errors,
      creatorName,
      creatorEmail,
      orgName,
      orgEmail,
      creatorComment,
      documentComment,
      isOpenMCX,
      isLoading,
      isDownloadLoading,
      exportFormat,
      creatorNameError,
      orgNameError,
      spdxType,
    } = this.state;

    const isSpdx3 = spdxType === '3.0';

    const getModalContent = () => {
      if (isDownloadLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup spdx">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '35%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.prepare_spdx_download')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup spdx">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '35%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.loading')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup spdx"
            >
              <div className="setting_popup_header">
                <h2 className="popup_name">{translate('modal.title.create_spdx_document')}</h2>
                <a
                  className="popup_close_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Scrollbars
                style={{
                  height: '690px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
              >
                <Form>
                  <div className="setting_popup_content_wrap">
                    <h3
                      className="content_title"
                    >
                      {translate('modal.title.creator_information')}
                    </h3>
                  </div>
                  <Form.Group unstackable widths={2}>
                    <Form.Field error={creatorNameError}>
                      <label
                        ref={(ref) => {
                          this.creatorName = ref;
                        }}
                      >
                        {translate('modal.title.creator_name')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </label>
                      <input
                        type="text"
                        value={creatorName}
                        onChange={this.handleCreatorNameChange}
                        placeholder={translate('modal.title.creator_name')}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.creator_email')}</label>
                      <input
                        type="text"
                        value={creatorEmail}
                        onChange={this.handleCreatorEmailChange}
                        placeholder={translate('modal.title.creator_email')}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.export_format')}</label>
                      <select
                        value={exportFormat}
                        disabled={isSpdx3}
                        onChange={this.handleExportFormat}
                      >
                        <option value={SPDX_EXTENSION_JSON}>{isSpdx3 ? 'JSON-LD' : 'JSON'}</option>
                        {!isSpdx3 && <option value={SPDX_EXTENSION_TAG}>TAG/VALUE</option>}
                        {!isSpdx3 && <option value={SPDX_EXTENSION_XML}>XML</option>}
                        {!isSpdx3 && <option value={SPDX_EXTENSION_RDF}>RDF</option>}
                        {!isSpdx3 && <option value={SPDX_EXTENSION_YAML}>YAML</option>}
                      </select>
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.spdx_version')}</label>
                      <select value={spdxType} onChange={this.handleSPDXType}>
                        <option value="2.0">SPDX 2.3</option>
                        <option value="3.0">SPDX 3.0</option>
                      </select>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths={2}>
                    <Form.Field error={orgNameError}>
                      <label
                        ref={(ref) => {
                          this.orgName = ref;
                        }}
                      >
                        {translate('modal.title.organization_name')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </label>
                      <input
                        type="text"
                        value={orgName}
                        placeholder={translate('modal.title.organization_name')}
                        onChange={this.handleOrgNameChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.organization_email')}</label>
                      <input
                        type="text"
                        value={orgEmail}
                        placeholder={translate('modal.title.organization_email')}
                        onChange={this.handleOrgEmailChange}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.TextArea
                    label={translate('modal.title.creator_comment')}
                    placeholder={translate('modal.place_holder.spdx_creator_comment')}
                    value={creatorComment}
                    onChange={this.handleCreatorCommentChange}
                  />
                  <Form.TextArea
                    label={translate('modal.title.document_comment')}
                    placeholder={translate('modal.place_holder.spdx_creator_comment')}
                    value={documentComment}
                    onChange={this.handleDocumentCommentChange}
                  />
                </Form>
              </Scrollbars>
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onClick={this.onSubmit}
                  onKeyUp={this.onSubmit}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
          <Modal open={isOpenWarnModal} onClose={this.closeWarnModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="left_button"
                      onClick={this.closeWarnModal}
                      onKeyUp={this.closeWarnModal}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="right_button"
                      onClick={this.runWithModalValue}
                      onKeyUp={this.runWithModalValue}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    };
    return (
      <Modal open={isOpenMCX} onClose={this.closeModal} className="create_spdx">
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(SPDXDocumentGenerator)));
